import { Box, Paper, Skeleton, Typography, useTheme } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { useIntl } from 'react-intl';

import { useDashboardOverallProgress } from './useDashboardOverallProgress';
import { AnnotationProgress } from '../../types/responseTypes';

interface DashboardOverallProgressProps {
  annotationProgressData: AnnotationProgress | null;
  isAnnotationProgressDataLoading: boolean;
}
export const DashboardOverallProgress = ({
  annotationProgressData,
  isAnnotationProgressDataLoading,
}: DashboardOverallProgressProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const { annotationProgressPieSeriesData, size } = useDashboardOverallProgress({
    annotationProgressData,
  });

  if (!annotationProgressData && !isAnnotationProgressDataLoading) {
    return null;
  }
  return (
    <Paper
      sx={{
        p: theme.spacing(6),
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
      }}
    >
      <Typography variant="h6">
        {formatMessage({ id: 'metrics.dashboard.overallProgress.title' })}
      </Typography>
      {isAnnotationProgressDataLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Skeleton variant="circular" {...size} />
        </Box>
      ) : (
        <PieChart
          series={[{ data: annotationProgressPieSeriesData, innerRadius: 80 }]}
          {...size}
          slotProps={{
            legend: {
              direction: 'column',
              position: {
                vertical: 'top',
                horizontal: 'right',
              },
            },
          }}
        />
      )}
    </Paper>
  );
};
